export default "__VITE_ASSET__CcVQ5WyX__"